import { Box, Flex, Paper, Radio, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { Client } from 'src/users';

type ClientRowProps = {
  client: Client;
  lastReviewDateLabel?: string;
  selected: boolean;
  onSelect: (client: Client) => void;
};

export function ClientRow({ client, lastReviewDateLabel, selected, onSelect }: ClientRowProps) {
  return (
    <Paper
      radius="12"
      withBorder
      px="md"
      py="sm"
      role="button"
      tabIndex={0}
      onClick={() => onSelect(client)}
      styles={theme => ({
        root: {
          cursor: 'pointer',
          borderColor: selected ? theme.colors.brand[6] : 'var(--default-border-color)',
          boxShadow: 'none',
          userSelect: 'none',
        },
      })}
    >
      <Box
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          columnGap: 'var(--mantine-spacing-xxs)',
        }}
      >
        <Flex align="center" gap="md" miw={0}>
          <Radio
            checked={selected}
            onChange={() => onSelect(client)}
            color="brand"
            size="md"
            iconColor="white"
          />

          <Text fw={FONT_WEIGHTS.semibold} size="sm" truncate c="gray.8">
            {client.firstName} {client.lastName}
          </Text>
        </Flex>

        <Flex align="center" miw={0}>
          <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.7">
            {client.emailAddress ?? ''}
          </Text>
        </Flex>

        <Flex align="center" justify="flex-end">
          <Text size="xs" c="gray.7" style={{ whiteSpace: 'nowrap' }} fw={FONT_WEIGHTS.medium}>
            {lastReviewDateLabel
              ? `Last review date: ${lastReviewDateLabel}`
              : 'Last review date: —'}
          </Text>
        </Flex>
      </Box>
    </Paper>
  );
}
